import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import en from './locales/en-US.json';
import es from './locales/es-ES.json';
import hi from './locales/hi-IN.json';
import ja from './locales/ja-JP.json';
import ko from './locales/ko-KR.json';
import pt from './locales/pt-BR.json';
import th from './locales/th-TH.json';
import vi from './locales/vi-VN.json';
import VuePhotoPreview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(VueI18n)
Vue.use(VuePhotoPreview)

Vue.config.productionTip = false

const messages = {
  en: en,
  es: es,
  hi: hi,
  ja: ja,
  ko: ko,
  pt: pt,
  th: th,
  vi: vi
}

const i18n = new VueI18n({
  locale: 'en', // 设置默认语言
  messages, // 设置语言包
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
